import { ApiRequest } from './helper';

export async function list(a) {
  try {
    const response = await ApiRequest('GET', null, `${process.env.REACT_APP_API_URL}/api/Common/ImproxyWorkers`);

    if (response.ok) {
      const data = await response.json();
      a.success(data);
    } else {
      a.error(response.status);
    }
  } catch (error) {
    a.error();
  }
}
